import dayjs from "dayjs";

import { useMemo } from "react";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { Card, CardContent, Switch, Tooltip, Typography, Box } from "@mui/material";

import usePlatform from "@/hooks/usePlatform";

const TrackPriceCard = (props: {
  dateRange: number[];
  value: boolean;
  onChange: (v: boolean) => void;
  onRouteRequest: (v: boolean) => void;
}) => {
  const { isPc } = usePlatform();

  const handleToggle = () => {
    props.onChange(!props.value);
  };

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Prevent double triggering when clicking the switch directly
    event.stopPropagation();
    props.onChange(event.target.checked);
  };

  const dateRangeText = useMemo(() => {
    let dateStr;
    const [start, end] = props.dateRange;

    if (start < end) {
      if (dayjs(start).isSame(end, "M")) {
        dateStr =
          dayjs(start).format("MMM") +
          " " +
          dayjs(start).format("DD") +
          "-" +
          dayjs(end).format("DD");
      } else {
        dateStr =
          dayjs(start).format("MMM") +
          " " +
          dayjs(start).format("DD") +
          " - " +
          dayjs(end).format("MMM") +
          " " +
          dayjs(end).format("DD");
      }
    } else {
      dateStr = dayjs(start).format("MMM") + " " + dayjs(start).format("DD");
    }

    if (dateStr.toLowerCase().includes("invalid")) {
      return "";
    }
    return dateStr;
  }, [props.dateRange]);

  const TrackPricePC = (
    <Box
      onClick={handleToggle}
      sx={{
        display: "flex",
        alignItems: "center",
        border: "1px solid",
        borderColor: "grey.500",
        // borderColor: (theme) => theme.palette.primary.main,
        borderRadius: "8px", // Tailwind's `rounded-lg` ≈ 0.5rem = 8px
        cursor: "pointer",
        // maxWidth: "1280px",
        width: "fit-content",
        paddingX: "15px",
        minWidth: "390px", // Ensure it has a minimum width for better layout

      }}
    >
      <InsightsOutlinedIcon color="primary" />
      <div className="flex items-center mx-[10px]">
        <div className="flex-1">
          <Typography variant="body1" color="primary" sx={{ fontWeight: "bold", fontSize: "1rem" }}>
            AwardTool Advanced Alert
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{ fontWeight: 500, letterSpacing: "0.01em", marginTop: "-4px", fontSize: "0.9rem" }}
          >
            Stop Refreshing. Start Receiving.
          </Typography>
        </div>

        <Tooltip
          sx={{ size: 10 }}
          title="Set alerts for multiple days and airports with advanced filters. Alerts will be actively checked every 3 to 6 hours, with more frequent checks for pro users. "
          onClick={(e) => e.stopPropagation()}
        >
          <InfoOutlinedIcon
            sx={{ fontSize: 16, marginLeft: "4px", marginRight: "-14px" }}
            color="primary"
          />
        </Tooltip>
      </div>

      <div className="flex items-center">
        {/* <Typography variant="body1" color="primary">
          {dateRangeText}
        </Typography> */}
        <Switch
          inputProps={{ "aria-label": "controlled" }}
          checked={props.value}
          onChange={handleSwitchChange}
        />
        <NotificationsActiveIcon color="primary" />
      </div>

      <div className="flex-1" />
    </Box>
  );

  const TrackPriceMobile = (
    <Card
      className="pb-[1px] mt-[-12px] mx-auto max-w-md cursor-pointer hover:shadow-md transition-shadow duration-200"
      elevation={1}
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      onClick={handleToggle}
    >
      <CardContent
        className="flex items-center"
        sx={{
          marginTop: -1,
          paddingTop: 2,
          ":last-child": {
            paddingBottom: 1,
          },
        }}
      >
        <NotificationsActiveIcon color="primary" />
        <div className="ml-[10px]">
          <Typography variant="body1" color="primary" sx={{ fontWeight: "bold", fontSize: "1rem" }}>
            AwardTool Advanced Alert
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{ fontWeight: 500, letterSpacing: "0.01em", marginTop: "-4px", fontSize: "0.9rem" }}
          >
            Stop Refreshing. Start Receiving.
          </Typography>
        </div>
        <Switch
          inputProps={{ "aria-label": "controlled" }}
          checked={props.value}
          onChange={handleSwitchChange}
        />

        <div className="flex-1" />
      </CardContent>
    </Card>
  );

  return isPc ? TrackPricePC : TrackPriceMobile;
};

export default TrackPriceCard;
